import { AxiosInstance, AxiosRequestConfig } from "axios";
import { ExportableOrganisationApi } from "../exportableApi/ExportableOrganisationApiModel";
import http from "../Http";
import { IFlightPathApiResponse } from "../BaseApiModel";

export class PlacesApi extends ExportableOrganisationApi<any> {
  controller: string = "places";

  constructor(http: AxiosInstance) {
    super(http, "places");
  }

  getAllPlaces = async (
    organisationId: number,
    config?: AxiosRequestConfig
  ): Promise<IFlightPathApiResponse<FP.Entities.IPlaceDetail[]>> => {
    const url = `${this.url}/${organisationId}/${this.controller}`;
    let res = await this.http.get(url, config);
    return res.data;
  };
  getAllPlacesForPlaceMap = async (
    organisationId: number,
    projectId?: number,
    config?: AxiosRequestConfig
  ): Promise<IFlightPathApiResponse<FP.Entities.IPlaceDetail[]>> => {
    const params = projectId ? `?projectId=${projectId}` : "";
    const url = `${this.url}/${organisationId}/${this.controller}/map${params}`;
    const res = await this.http.get(url, config);
    return res.data;
  };

  getAllPlacesForProjectDashboardMap = async (
    organisationId: number,
    projectId: number,
    config?: AxiosRequestConfig
  ): Promise<IFlightPathApiResponse<FP.Entities.IPlaceDetail[]>> => {
    const url = `${this.url}/${organisationId}/places/${projectId}/project-map`;
    let res = await this.http.get(url, config);
    return res.data;
  };

  getPlaceImpactProjectCount = async (
    organisationId: number,
    groupId: number,
    projectId?: number,
    config?: AxiosRequestConfig
  ) => {
    const url = `${this.url}/${organisationId}/${this.controller}/map/pie-chart/${groupId}`;
    const params = projectId ? { projectId } : {};
    let res = await this.http.get(url, { ...config, params });
    return res.data;
  };

  getPlacesByGroupId = async (
    organisationId: number,
    placeGroupId: number,
    config?: AxiosRequestConfig
  ): Promise<IFlightPathApiResponse<FP.Entities.IPlaceDetail[]>> => {
    const url = `${this.url}/${organisationId}/place-groups/${placeGroupId}/places`;
    let res = await this.http.get(url, config);
    return res.data;
  };

  deletePlace = async (
    organisationId: number,
    placeIds: number[],
    config?: AxiosRequestConfig
  ): Promise<IFlightPathApiResponse<boolean>> => {
    const res = await this.http.post(`${this.url}/${organisationId}/places/delete-range`, placeIds, config);
    return res.data;
  };

  createPlace = async (
    organisationId: number,
    payload: {
      name: string;
      streetAddress: string;
      city: string;
      country: string;
      latitude: number;
      longitude: number;
      placeGroupId: number;
    }
  ): Promise<any> => {
    try {
      const res = await this.http.post(`${this.url}/${organisationId}/places`, payload);
      return res.data;
    } catch (error) {
      return error;
    }
  };

  updatePlaceField = async (
    organisationId: number,
    placeId: number,
    placeField: string,
    payload: { Text?: string; NumericField?: number }
  ): Promise<void> => {
    await this.http.put(`${this.url}/${organisationId}/places/${placeId}/${placeField}`, payload);
  };
  getUnassignedPlaces = async (organisationId: number, placeGroupId: number, config?: AxiosRequestConfig) => {
    const res = await this.http.get(`${this.url}/${organisationId}/places/unassigned`);
    return res.data;
  };
  getPlaces = async (organisationId: number, config?: AxiosRequestConfig): Promise<any> => {
    const url = `${this.url}/${organisationId}/places`;
    const res = await this.http.get(url, config);
    return res.data;
  };
}
const instance = new PlacesApi(http);

export default instance;
